/*

FILE USAGE

Acts as a export file for storing the data of API links and other core features.
Please revert to their names if you want to make changes.

*/

export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes";
export const TIMEOUT_SECONDS = 10;
export const API_KEY = "cc142dbb-05f7-4baa-bcef-0677822469ee";
export const RES_PER_PAGE = 10;
